import { useLocation, useNavigate, useRouteError } from 'react-router-dom';
import { Button, Result, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { isNullOrWhiteSpaces } from './shared/utils/strings';
import { jsonBase64Decode } from './utils';
const { Paragraph, Text } = Typography;

export interface ErrorPageProps {
  message?: string;
  redirectTo?: { label: string; url?: string; onClick?: () => void };
}

const ErrorPage: React.FC<ErrorPageProps> = ({ message = undefined, redirectTo = undefined }) => {
  const error = useRouteError() as any;
  const navigate = useNavigate();
  const { t } = useTranslation();
  console.error({ error });
  return (
    <div
      style={{
        padding: '1% 20%'
      }}
    >
      <Result
        status="500"
        title={t('Oops')}
        subTitle={t('Sorry, something went wrong.')}
        extra={
          <Button onClick={redirectTo?.onClick ?? (() => navigate(redirectTo?.url ?? '/'))} type="primary">
            {redirectTo?.label ?? t('Back Home')}
          </Button>
        }
      >
        {(!isNullOrWhiteSpaces(message) || error?.statusText || error?.message) && (
          <div className="desc">
            <Paragraph>
              <Text
                strong
                style={{
                  fontSize: 16
                }}
              >
                {t('Error message')}:
              </Text>
            </Paragraph>
            {[error?.statusText, error?.message, error?.data, message]
              .filter((x) => x)
              .map((txt, idx) => (
                <Paragraph key={idx}>
                  <CloseCircleOutlined style={{ color: 'red' }} /> {t(txt)}
                </Paragraph>
              ))}
          </div>
        )}
      </Result>
    </div>
  );
};

export const Page404 = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage
      message={t('Página no encontrada')}
      redirectTo={{
        label: t('Back Home'),
        onClick: () => {
          window.location.href = `${window.REACT_APP_WEBSITE_BASE_URI}/default-user-page`;
        }
      }}
    />
  );
};

export const ErrorView = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const dataQs = new URLSearchParams(location?.search ?? '').get('data') as string;
  const errorData = jsonBase64Decode<{ message?: string; action?: { label?: string; url?: string } }>(dataQs, {} as any);

  const nullT = (s: any) => {
    if (isNullOrWhiteSpaces(s)) return s;
    return t(s);
  };

  return (
    <ErrorPage message={nullT(errorData?.message)} redirectTo={{ label: nullT(errorData?.action?.label as any), url: errorData?.action?.url }} />
  );
};

export default ErrorPage;
